import { TTheme } from "../../../types/theme-types";
import styles from "./alert-banner.module.less";

export type TLevelOfUrgency = "neutral" | "important";

export type TAlertBannerProps = {
  content: React.ReactNode;
  levelOfUrgency: TLevelOfUrgency;
};

const getThemeFromLevelOfUrgency = (levelOfUrgency: TLevelOfUrgency): TTheme | null => {
  switch (levelOfUrgency) {
    case "neutral": {
      return "dark-blue";
    }
    case "important": {
      return null;
    }

    default:
      return null;
  }
};

const getIconFromLevelOfUrgency = (levelOfUrgency: TLevelOfUrgency) => {
  switch (levelOfUrgency) {
    case "important": {
      return "ui-icon-error";
    }

    case "neutral":
    default:
      return "ui-icon-info";
  }
};

const AlertBanner = ({ content, levelOfUrgency = "neutral" }: TAlertBannerProps) => {
  const theme = getThemeFromLevelOfUrgency(levelOfUrgency);
  const icon = getIconFromLevelOfUrgency(levelOfUrgency);

  return (
    <div className={`${styles.wrapper} ${styles[levelOfUrgency]} ${theme ? "theme-" + theme : ""}`}>
      <span className={`${styles.icon} ${icon}`} />
      <div className={[styles.content, "body-s mb-0"].join(" ")}>{content}</div>
    </div>
  );
};

export default AlertBanner;
